import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WeeklyConsolPlanningRoutingModule } from './weekly-consol-planning-routing.module';
import { WeeklyConsolPlanningFormComponent } from './weekly-consol-planning-form/weekly-consol-planning-form.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { WeeklyPlanningDateAdapter } from './weekly-planning-date-adapter';
import { PreviousVesselPopupComponent } from './weekly-consol-planning-form/previous-vessel-popup/previous-vessel-popup.component';
import { DatePipe } from '@angular/common';


@NgModule({
  declarations: [
    WeeklyConsolPlanningFormComponent,
    PreviousVesselPopupComponent
  ],
  imports: [
    CommonModule,
    WeeklyConsolPlanningRoutingModule,
    SharedModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatDialogModule
  ],
   providers: [
    { provide: DateAdapter, useClass: WeeklyPlanningDateAdapter },
    DatePipe
  ]
})
export class WeeklyConsolPlanningModule { }
